export const ALLERGENS = [
  ["GLU", "Cereali con glutine"], ["CRO", "Crostacei"], ["UOV", "Uova"], ["PES", "Pesce"], ["ARA", "Arachidi"],
  ["SOI", "Soia"], ["LAT", "Latte"], ["FRU", "Frutta a guscio"], ["SED", "Sedano"], ["SEN", "Senape"],
  ["SES", "Sesamo"], ["SOL", "Anidride solforosa e solfiti"], ["LUP", "Lupini"], ["MOL", "Molluschi"],
];
export const ALLERGEN_NAMES = Object.fromEntries(ALLERGENS);

export const RECIPE_STATUS = {
  bozza: { label: "Bozza", cls: "badge-grey" },
  da_validare: { label: "Da validare", cls: "badge-amber" },
  approvata: { label: "Approvata", cls: "badge-green" },
  archiviata: { label: "Archiviata", cls: "badge-grey" },
};
export const STOCK_STATUS = {
  ok: { label: "Scorta OK", cls: "badge-green" },
  vicino_soglia: { label: "Vicino soglia", cls: "badge-amber" },
  sotto_scorta: { label: "Sotto scorta", cls: "badge-red" },
  in_scadenza: { label: "In scadenza", cls: "badge-amber" },
};
export const PROD_STATUS = {
  da_iniziare: { label: "Da iniziare", cls: "badge-grey" },
  in_corso: { label: "In corso", cls: "badge-primary" },
  pronta: { label: "Pronta", cls: "badge-green" },
};
export const ORDER_STATUS = {
  bozza: { label: "Bozza", cls: "badge-grey" },
  inviato: { label: "Inviato", cls: "badge-primary" },
  confermato: { label: "Confermato", cls: "badge-primary" },
  in_consegna: { label: "In consegna", cls: "badge-amber" },
  ricevuto_parziale: { label: "Ricevuto parziale", cls: "badge-amber" },
  ricevuto: { label: "Ricevuto", cls: "badge-green" },
  fatturato: { label: "Fatturato", cls: "badge-green" },
  chiuso: { label: "Chiuso", cls: "badge-grey" },
  annullato: { label: "Annullato", cls: "badge-grey" },
  rifiutato: { label: "Rifiutato", cls: "badge-red" },
};
export const MOVEMENT_LABELS = { carico: "Carico", scarico: "Scarico", produzione: "Produzione", spreco: "Spreco", rettifica: "Rettifica", reso: "Reso" };
export const WASTE_LABELS = { scaduto: "Scaduto", rovinato: "Rovinato", errore_produzione: "Errore di produzione", altro: "Altro" };
export const LOCATION_TYPE_LABELS = { cella_frigo: "Cella frigo", cella_negativa: "Cella negativa", dispensa: "Dispensa", cantina: "Cantina", altro: "Altro" };
export const RECIPE_CATEGORIES = ["Antipasti", "Primi", "Secondi", "Dolci", "Basi"];
export const ARTICLE_CATEGORIES = ["Carne", "Pesce", "Latticini", "Ortofrutta", "Secco", "Bevande", "Spezie e condimenti", "Altro"];
export const ARTICLE_UNITS = ["kg", "g", "l", "ml", "pz"];
export const INGREDIENT_UNITS = ["g", "kg", "ml", "l", "pz", "porz"];
export const FOOD_COST_TARGET = 30;

const eur = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" });
const num = new Intl.NumberFormat("it-IT", { maximumFractionDigits: 3 });
export const fmtMoney = (n) => (n == null ? "—" : eur.format(n));
export const fmtNum = (n) => (n == null ? "—" : num.format(n));
export const fmtQty = (n, unit) => (n == null ? "—" : `${num.format(n)} ${unit || ""}`.trim());
export const fmtPct = (n) => (n == null ? "—" : `${num.format(Math.round(n * 10) / 10)} %`);
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
export const longDate = (d = new Date()) => d.toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

const UNITS = { g: ["mass", 1], kg: ["mass", 1000], ml: ["vol", 1], l: ["vol", 1000], pz: ["pz", 1], porz: ["porz", 1] };
export function convertQty(qty, from, to) {
  const f = UNITS[from], t = UNITS[to];
  if (!f || !t || f[0] !== t[0]) return qty;
  return (qty * f[1]) / t[1];
}

export function mergeAllergen(target, code, state) {
  if (state !== "presente" && state !== "tracce") return;
  if (!target[code] || state === "presente") target[code] = state;
}

// Live preview of cost & allergens (mirrors backend services.compute_recipe)
export function computeRecipeLive(form, articlesById, recipesById) {
  let cost = 0;
  const allergens = {};
  const rows = (form.ingredients || []).map((ing) => {
    const qty = Number(ing.qty) || 0;
    const waste = Number(ing.waste_pct) || 0;
    const gross = waste >= 0 && waste < 100 ? qty / (1 - waste / 100) : qty;
    let rowCost = 0, name = "";
    if (ing.type === "recipe") {
      const sub = recipesById[ing.ref_id];
      name = sub?.name || "Base eliminata";
      if (sub) {
        rowCost = (sub.cost_total / Math.max(Number(sub.portions) || 1, 0.0001)) * gross;
        Object.entries(sub.allergens || {}).forEach(([c, s]) => mergeAllergen(allergens, c, s));
      }
    } else {
      const a = articlesById[ing.ref_id];
      name = a?.name || "Articolo eliminato";
      if (a) {
        rowCost = convertQty(gross, ing.unit || a.unit, a.unit) * (Number(a.unit_cost) || 0);
        Object.entries(a.allergens || {}).forEach(([c, s]) => mergeAllergen(allergens, c, s));
      }
    }
    cost += rowCost;
    return { ...ing, name, row_cost: rowCost };
  });
  (form.manual_allergens || []).forEach((m) => mergeAllergen(allergens, m.code, m.state));
  const portions = Math.max(Number(form.portions) || 1, 0.0001);
  const price = Number(form.price) || 0;
  const vat = form.vat_rate == null || form.vat_rate === "" ? 10 : Number(form.vat_rate);
  const priceNet = price / (1 + vat / 100);
  const costPortion = cost / portions;
  return {
    rows, allergens, cost_total: cost, cost_portion: costPortion, price_net: priceNet,
    food_cost_pct: priceNet > 0 ? (costPortion / priceNet) * 100 : null, margin: priceNet - costPortion,
  };
}
